+function($, window, document) {
	'use strict';
	
	var scope;
	
	var CustomerFeedback = function(element, options) {
		this.options = options;
		this.$element = $(element);
		this.$form = this.$element.parents('form');
		this.$modalBody = this.$element.find('.modal-body');
		this.$feedback = $('.feedback');
		
		scope = this;
		
		this.initialize();
	};
	
	CustomerFeedback.DEFAULTS = {
		feedbackTriggerWidth: 180
	};
	
	CustomerFeedback.prototype.initialize = function() {
		this.centerDialog();
		
		this.observeSubmit();
	};
	
	CustomerFeedback.prototype.observeSubmit = function() {
		this.$form.on('submit', function(event) {
			event.preventDefault();
			
			if ( ! $(this).data('bs.validator').hasErrors()) {
				$.publish('showajaxnotification.sn', ['SENDING...']);
				
				$.post('/feedback/save', $(this).serialize()).done(function(result) {
					if (result.success) {
						scope.$element.modal('hide');
						
						scope.$feedback.css('width', 'auto');
						scope.$feedback.find('p').show();
						
						setTimeout(function() {
							scope.$feedback.css('width', scope.options.feedbackTriggerWidth);
							scope.$feedback.find('p').hide();
						}, 3000);
						
						scope.resetForm();
					}else {
						scope.$modalBody.prepend('<p class="alert alert-error">' + result.feedback + '</p>');
					}
				}).always(function() {
					$.publish('hideajaxnotification.sn');
				});
			}
			
			return false;
		});
	};
	
	CustomerFeedback.prototype.resetForm = function() {
		this.$form.find('input').val('');
		this.$form.find('textarea').val('');
	};
	
	CustomerFeedback.prototype.centerDialog = function() {
		var dlg = this.$element.find('.modal-dialog'),
			win = $(window),
			winWidth = win.width(),
			winHeight = win.height();
		
		this.$element.on('shown.bs.modal', function (e) {
			var height = dlg.height(),
				width = dlg.width();
			
			scope.$element.css('margin-top', -(height / 2));
		});
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.CustomerFeedback'),
    			options = $.extend({}, CustomerFeedback.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.CustomerFeedback', (data = new CustomerFeedback(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.Dialog;
	
	$.fn.CustomerFeedback = Plugin;
	$.fn.CustomerFeedback.Constructor = CustomerFeedback;
	
	$.fn.CustomerFeedback.noConflict = function () {
	    $.fn.CustomerFeedback = old;
	    return this;
	};
	
	//data-api
	$(document).on('click.sn.data-api', '[data-active="customer-feedback"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	
	    if ($this.is('a')) e.preventDefault()
	
	    Plugin.call($target, {})
	});
}(jQuery, window, document);